import { createContext, useContext } from 'react';
import { VerificationMethod } from '../@types/VerificationMethod';

export interface ClientConfig {
  clientId: string;
  baseUrl: string;
  verificationMethods?: VerificationMethod[];
  hideToasterOnSuccess?: boolean;
  userFirstName?: string;
  userLastName?: string;
  nameEditable?: boolean;
  nameCheckEnableForVeriff?: boolean;
  userId?: string;
  isDarkModeSupported?: boolean;
}

export const ClientConfigContext = createContext<ClientConfig>({
  clientId: '',
  baseUrl: window.location.href,
});

export const useClientConfig = () => useContext(ClientConfigContext);
